import { Button } from "@/components/ui/button";
import { IconChatStop } from "@/components/ui/icons";
import { cn } from "@/lib/utils";
import React from "react";

export const StopChatButton = React.memo(
  ({
    isLoading,
    stop,
  }: {
    isLoading: boolean;

    stop: () => void;
  }) => {
    return (
      <div
        className={cn(
          "absolute top-[-7.3rem] bg-gradient-to-b from-[#13151900] from-0% to-[#131519] to-100% w-full h-[120px] flex flex-col justify-end pointer-events-none",
          !isLoading && "hidden"
        )}
      >
        <div
          className={cn(
            "flex py-2 items-center justify-center pointer-events-auto"
          )}
        >
          <Button
            variant="outline"
            onClick={() => {
              if (isLoading) {
                stop();
              }
            }}
            className="!bg-secondary-n-950 h-7 hover:!bg-secondary-300 !rounded-xl !border-none hover:!border-none !text-secondary-n-400 hover:!text-secondary-n-400 !shadow-none"
            size="sm"
          >
            <IconChatStop className="mr-2 w-3 h-3" />
            Stop generating
          </Button>
        </div>
      </div>
    );
  }
);
